import React, { useMemo, useState, useEffect,useRef} from 'react'
import './dashboard.scss'
import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser"
import Notify from "lib/Utils/Alert";
import Utils from 'lib/Utils/Utils';
import AuthData from "../../lib/Core/AuthData";
import PurchaserAuth from "../../lib/Core/Backend/Controllers/PurchaserAuth";
import Brand from "../../lib/Core/Backend/Controllers/Brand"
import CardType from "../../lib/Core/Backend/Controllers/CardType";
import Category from 'lib/Core/Backend/Controllers/Category';
import { data } from 'jquery';
import { Pagination } from 'react-bootstrap';
import { Link } from '@mui/material';
import OrderSummary from './OrderSummary';
import useCatalogs from "hooks/useCatalogs";
import html2pdf from 'html2pdf.js';
import Spinner from 'react-bootstrap/Spinner';
import { useHistory } from "react-router-dom";
import Catalogs from 'lib/Core/Backend/Controllers/Catalogs';
import PurchaseOrder from 'lib/Core/Backend/Controllers/PurchaseOrder';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row,Form,FormGroup,Label,Input,Collapse } from 'reactstrap';
import Select from "react-select";
import NotificationAlert from "react-notification-alert";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';



const dollarUSLocale = Intl.NumberFormat('en-US', {
    style: "currency",
    currency: "USD",
});

const securityGroups = [
    "purchaser"
]
const ITEMS_PER_PAGE = 10;
const CARDS_PER_PAGE = 10;
const MAX_VISIBLE_PAGES = 5; 

const CustomPagination = ({ totalItems, currentPage, onPageChange }) => {
	const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
	const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
	const renderPageNumbers = () => {
		if (totalPages <= MAX_VISIBLE_PAGES) {
			return pageNumbers.map((page) => (
				<Pagination.Item
					key={page}
					active={page === currentPage}
					onClick={() => onPageChange(page)}
				>
					{page}
				</Pagination.Item>
			));
		}
		const startPage = Math.max(1, currentPage - Math.floor(MAX_VISIBLE_PAGES / 2));
		const endPage = Math.min(totalPages, startPage + MAX_VISIBLE_PAGES - 1);

		const pages = [];
		if (startPage > 1) {
			pages.push(
				<Pagination.Ellipsis key="ellipsis-start" disabled />
			);
		}
		for (let page = startPage; page <= endPage; page++) {
			pages.push(
				<Pagination.Item
					key={page}
					active={page === currentPage}
					onClick={() => onPageChange(page)}
				>
					{page}
				</Pagination.Item>
			);
		}

		if (endPage < totalPages) {
			pages.push(
				<Pagination.Ellipsis key="ellipsis-end" disabled />
			);
		}

		return pages;
	};

	return (
		<Pagination className="pagination-custom d-flex justify-content-end me-3">
			<Pagination.First onClick={() => onPageChange(1)} />
			<Pagination.Prev onClick={() => onPageChange(currentPage > 1 ? currentPage - 1 : 1)} />
			{renderPageNumbers()}
			<Pagination.Next onClick={() => onPageChange(currentPage < totalPages ? currentPage + 1 : totalPages)}/>
			<Pagination.Last onClick={() => onPageChange(totalPages)} />
		</Pagination>
	);
};
const CustomCardPagination = ({ totalItems, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / CARDS_PER_PAGE);
    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);

    return (
        <Pagination>
            <Pagination.First onClick={() => onPageChange(1)} />
            <Pagination.Prev
                onClick={() => onPageChange(currentPage > 1 ? currentPage - 1 : 1)}
            />

            {pageNumbers.map((page) => (
                <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => onPageChange(page)}
                >
                    {page}
                </Pagination.Item>
            ))}

            <Pagination.Next
                onClick={() =>
                    onPageChange(currentPage < totalPages ? currentPage + 1 : totalPages)
                }
            />
            <Pagination.Last onClick={() => onPageChange(totalPages)} />
        </Pagination>
    );
};
const Dashboard = (props) => {
    const token = sessionStorage.getItem("accessToken");
    const cardTypeCtl = useMemo(() => new CardType(token), [token]);
    const { currencies } = useCatalogs();
    const tokenObject = JSON.parse(token);
    const newToken = tokenObject.token
    const authData = new AuthData(securityGroups);
    const brandCtl = useMemo(() => new Brand(authData.token), [authData.token]);
    const categoriesCtl = new Category(authData.token)
    const [showInfo, setShowInfo] = useState(false)
    const [orderDetail, setOrderDetail] = useState();
    const purchaserCtl = useMemo(() => new Purchaser(authData.token), [authData.token]);
    const catalogsCtl = useMemo(() => new Catalogs(authData.token), [authData.token]);
    const purchaseOrderCtl = useMemo(() => new PurchaseOrder(authData.token), [authData.token]);
    const [purchaserId, setPurchaserId] = useState(null);
    const [dashboardData, setDashboardData] = useState({});
    const [dashboard,setDashboard] = useState([])
    const [dashPrimaryData,setDashPrimarydata] = useState({})
    const [brandList, setBrandList] = useState([]);
    const [brandData,setBrandData] =  useState([]);
    const [brandSearchData,setBrandSearchData] = useState([]);
    const [notificationShown, setNotificationShown] = useState(false);
    const [categories,setCategories] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [funds,setFunds] = useState([])
    const [loader,setLoader] = useState(true)
    const auth = new PurchaserAuth(authData.token);
    const [modal, setModal] = useState(false);
    const [brandsFromPurchaser,setBrandsFromPurchaser] = useState([])
    const [brandPurchaser,setBrandPurchaser] = useState([])
    const toggle = () => { setModal(!modal) };
    const [paymentAdded,setPaymentAdded] = useState(false)
    const [count,setCount] = useState(0)
    const [id,setId]= useState(7489)
    const [excelLoader,setExcelLoader] = useState(false)
    const [csvLoader,setCsvLoader] = useState(false)
    const [fundShow,setFundShow] = useState(false);
    const [lowFundModal,setLowFundModal] = useState(false);
    const [fundsData,setFundsData] = useState({});
    const [lowFund,setLowFund] = useState("");
    const [lowFundLoader,setLowFundLoader] = useState(false);
    const [currencyOption,setCurrencyOption] = useState([]);
    const [currencyValue,setCurrencyValue] =  useState("");
    const [billingInfo, setBillingInfo] = useState(false);
    const [country, setCountry] = useState([]);
    const [registerLoader,setRegisterLoader] = useState(false);
    const [brandName,setBrandName] = useState("")
    const [orderData,setOrderData] = useState({})

    const [billingAdd, setBillingAdd] = useState({
            funds: '', // Set default to empty string
            currencyId: null,
            reference:'',
            purchaserId:null
})
    const alert  = useRef()
    const toggleFund = () => setFundShow(!fundShow)
    const toggleLowFund = () =>setLowFundModal(!lowFundModal);
    const togglePayment = () => setPaymentAdded(!paymentAdded);
    const history = useHistory();

    useEffect(() => {
        if (!authData.validateSecurityGroups()) {
            document.location.href = "/purchaser-auth/login";
        } else {
            auth.getSourceId((data) => {
                if (data.errorMessage || data.error) {
                    Notify(alert, 'danger', data.errorMessage ?? data.error)
         
                    if(data.errorMessage=="User does not exist."){
                        
                         sessionStorage.removeItem("accessToken")
                        window.location.href="purchaser-auth/login"
                    }
                } else {
                   
                    setPurchaserId(data);
                    setBillingAdd(prev => ({
                        ...prev,
                        purchaserId: data
                    }));
                }
            });
        }
    }, [])
   


    // useEffect(() => {
    //     setBrandPurchaser(
    //       brandsFromPurchaser.map((i) => ({
    //         id: i.id,
    //         brandName: brandList[i.brandId],
    //         brandId: i.brandId,
    //         purchaserFee: " $  " + i.purchaseFee.toFixed(2),
    //         purchaserDiscount: i.purchaseDiscount.toFixed(2),
    //         currency:i.currency,
    //         minimumAmount: i.minimumAmount,
    //         maximumAmount: i.maximumAmount,
    //         minimumQuantity: i.minimumQuantity,
    //         maximumQuantity: i.maximumQuantity,
    //       }))
    //     );
    //   }, [brandsFromPurchaser]);

    useEffect(() => {
        if (purchaserId) {
            purchaserCtl.purchaserDashboard(purchaserId, (data) => {
                if (data && !data.error) {
                    let purchaseDashboard = data?.currentOrderList?.map((order) => {
						let orderCurrency = currencies.find(currency => currency.id === order.currencyId)
						const currencyFormat = new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: orderCurrency?.code ?? 'USD'
						})
						
						order.totalAmount = currencyFormat.format(order.totalAmount);
						order.subtotal = currencyFormat.format(order.subtotal)
						return { ...order, currency: orderCurrency?.code ?? 'USD' };
					});

                    setDashboard(purchaseDashboard)
                    setDashPrimarydata(data)
                    setLoader(false)
                    let array = data?.brandList?.sort((a, b) => {
                        var textA = a.brandName.toUpperCase();
                        var textB = b.brandName.toUpperCase();
                        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                    });
                    // setBrandList(array)
                }
                else{
             
                }
            })
        }

    }, [purchaserId])
    


    // useEffect(()=>{
    //     if(purchaserId){
    //         purchaserCtl.getAllBrandsLimits(purchaserId, (dat) => {
    //             if (dat && !dat.error) {
    //               setBrandsFromPurchaser(dat);
    //             } else {
    //               setBrandsFromPurchaser([]);
    //             }
    //           });
    //     }
        
    // },[purchaserId])

    useEffect(()=>{
        brandCtl.all(data => {
           let brandLogos = [];
            data.result.forEach(brand => {
              brandLogos.push(
                {
                  id: brand.id,
                  logo: brandCtl.logo(brand.name, true)
                }
              );
            });
        if(purchaserId){
            purchaserCtl.availableBrands(purchaserId, (data) => {
                if(data && !data.error){
        
                  const discount = [];
                  const fee = [];
                  const purchaseBrands = [];
        
                  for (var i = 0; i < data.brands.length; i++)
                  {
                    discount.push(data.brands[i]?.purchaseDiscount);
                    fee.push(data.brands[i]?.purchaseFee);
                    purchaseBrands.push(data.brands[i]?.id);
                  }
        
        
                const brands = [];
                const sortedDiscount = [];
                const sortedFee = [];
        
                purchaserCtl.activeCards(purchaserId, cardData => {
                  Object.keys(data.brandList).forEach((brandId, idx) => {
        
                      if (cardData && !cardData.error){
                  
                    for (var i = 0; i < purchaseBrands.length; i++)
                    {
                        if (purchaseBrands[i] === parseInt(brandId))
                        {
                            sortedDiscount.push(discount[i]);
                            sortedFee.push(fee[i]);
                        }
        
                    }
                          brands.push(
                            {
                              id: brandId,
                              name: data.brandList[brandId],
                              purchaseFee: data.brands.purchaseFee,
                              purchaseDiscount: sortedDiscount[idx],
                              purchaseFee: sortedFee[idx],
                              logo: brandLogos.find(logo => logo.id === parseInt(brandId)).logo || 'Not Found',
                              cards: cardData.filter(card => card.brandId === parseInt(brandId)),
                            }
                          );
                       
                        if(idx + 1 ===  Object.keys(data.brandList).length){
                          
                          
                            const newBrands = brands.map((e) => {
                              for(let val of brandPurchaser){
                                if(e.id === val.brandId){
                                  e.purchaseDiscount = val.purchaserDiscount;
                                  e.purchaseFee = val.purchaserFee
                                }
                              }
                              return e
                            })
                          setBrandList(newBrands)  
                         
                        }
                      } else {
                        Notify(alert, 'danger', cardData.error);
                      }
                    })
                    
                  });
                  
                } else {
                  Notify(alert, 'danger', data.error);
                }
              });
        }
    })
},[purchaserId])

    useEffect(()=>{
        if(purchaserId){
            purchaserCtl.allFunds(purchaserId,(data)=>{
                if(data && !data.error){
                 setFunds(data)
                }

            })
        }
        else{
           
        }

    },[purchaserId])

    useEffect(()=>{
        if(purchaserId){
            purchaserCtl.purchaserDashboardBrand(purchaserId,(data)=>{
                if(data && !data.error){
                    let purchaseDashboard = data?.map((order) => {
						let orderCurrency = currencies.find(currency => currency.id === order.currencyId)
						const currencyFormat = new Intl.NumberFormat('en-US', {
							style: 'currency',
							currency: orderCurrency?.code ?? 'USD'
						})
						
						order.purchaseFee = order.purchaseFeeType === "PERCENTAGE" ? order.purchaseFee.toFixed(2) + '%' : currencyFormat.format(order.purchaseFee);
						return { ...order, currency: orderCurrency?.code ?? 'USD' };
					});
                    purchaseDashboard.sort((a, b) => a.name.localeCompare(b.name));
                 setBrandData(purchaseDashboard)
                 setBrandSearchData(purchaseDashboard)
                    setLoader(false)
                }
                else{
               
                }
              })
        }
    },[purchaserId])

    const fetchPurchaserData = ()=> {
        
        purchaserCtl.purchaserCheck(purchaserId, (data) => {
          if (data && !data.error) {
            if(data?.users[0]?.enabled == false){
              sessionStorage.removeItem("accessToken")
                window.location.href="purchaser-auth/login"
        }
            
          }else{
           if((data?.errorMessage=="Purchaser not found"&& data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
    
              Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                  sessionStorage.removeItem("accessToken")
                  window.location.href="purchaser-auth/login"
              }
              if((data?.errorMessage.includes("Username was not found") && data?.errorCode=="BAD_REQUEST") || data?.errorMessage=="There is no records on the Purchaser brand limits table"){
        
                Notify(alert, 'danger', data?.errorMessage ?? data?.error);
                    sessionStorage.removeItem("accessToken")
                    window.location.href="purchaser-auth/login"
                }
          }
    })
    }
    
    
    useEffect(()=>{  
        if(purchaserId)  {
            fetchPurchaserData();
        }
  },[purchaserId])

    useEffect(()=>{
        categoriesCtl.all((data)=>{
            if(data && !data.error){
             setCategories(data)
            }
        
        })
    },[])

    useEffect(()=>{
            if (!!purchaserId){
            purchaserCtl.billingaddress(purchaserId, (billingData) => {
                if (billingData.errorMessage || billingData.error) {
                  // Notify(alert, "danger", billingData.errorMessage ?? billingData.error);
                } else {
                    let obj = {
                        countryId: billingData?.billingCoutryId,
                        street: billingData?.billingAddress,
                        city: billingData?.billingCity,
                        postalCode: billingData?.billingPostalCode
                      };
              
                      
                      setBillingAdd(prevState => ({
                        ...prevState,
                        ...obj,           
                        funds: prevState.funds || '', 
                        currencyId: prevState.currencyId || null, 
                        reference: prevState.reference || ''
                      }));
                    
                }
              })
            }
        },[purchaserId])

        useEffect(() => {
                catalogsCtl.countries((data) => {
                    if (data && !data.error) {
                        setCountry(data);
                    } else {
                        Notify(alert, "danger", data.error);
                    }
                });
            }, [catalogsCtl])
        

    const usDollarFunds = funds.filter(fund => fund.currencyName === "USD");

    const getCategoryName = (categoryId) => {
        const category = categories?.find(category => category.id === categoryId);
        return category ? category.name : '...Loading';
    }


    const onOpenInfoModal = (data) => {
        setShowInfo(!showInfo)
        setOrderDetail(data);
    }
    const statusData = (data) => {
        switch (data) {
            case 1:
                return "Open";

            case 2:
                return "Processing";

            case 3:
                return "Cancelled";

            case 4:
                return "Completed";

            case 5:
                return "Processing";
            case 6:
            case 7:
            case 9:
            case 10:
                return "Awaiting payment";
            case 8:
                return "Processing";
            case 11:
            case 12:
            case 13:
                return "Processing";
            case 15:
                return "Temporary out of stock";
            default:
                return "Processing";
        }
    }
    const [currentPage, setCurrentPage] = useState(1);
    const [cardCurrentPage, setCardCurrentPage] = useState(1);
    const [giftShow, setGiftShow] = useState(false);
    const [cardTypeData, setCardTypeData] = useState([]);
    
    const toggleGiftCard = () => {
        setGiftShow(!giftShow);
    }
    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const handleCardPageChange = (pageNumber) => {
        setCardCurrentPage(pageNumber);
    };

    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    const endIndex = startIndex + ITEMS_PER_PAGE;
    const currentBrandData = brandData?.slice(startIndex, endIndex);

    const cardStartIndex = (cardCurrentPage - 1) * CARDS_PER_PAGE;
    const cardEndIndex = cardStartIndex + CARDS_PER_PAGE;
    const cardCurrentBrandData = cardTypeData?.slice(cardStartIndex, cardEndIndex);
    

    const handleCloseGiftModal = () => {
        setGiftShow(false)
    }
    const giftcardModal = (giftcardData,brandName) => {
        setBrandName(brandName)
        
        setCardTypeData(giftcardData);
        toggleGiftCard();
    }
    // Example createTable function

    const createTable = (data) => {
        let tbl = document.createElement("table");
        let tblHead = document.createElement('thead');
        let tblPurchaserHead = document.createElement('thead');
        let tblBody = document.createElement("tbody");

        tbl.classList.add('table', 'table-bordered');
        tblHead.classList.add('thead-dark');
        tblPurchaserHead.classList.add('thead-dark');

        let headers = document.createElement('tr');
        let headerLabels = [
            `<div class= 'row'>
        <div class= 'col-4'>Brands</div>
        <div class= 'col-4'>Discount</div>
        <div class= 'col-4'>Fee</div>
      </div>`,
            'Card Types'];
        headerLabels.forEach(header => {
            let cell = document.createElement('th');
            cell.innerHTML = header;
            headers.appendChild(cell);

        });

        data?.sort((a, b) => {

            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        }).forEach((brand, brandIdx) => {
            let brandRow = document.createElement('tr');
            let brandName = document.createElement('th');
            brandName.setAttribute('rowspan', `${brand?.cards?.length === 0 ? 1 : brand?.cards?.length}`);
            brandName.setAttribute('scope', 'row');
            if (brandIdx % 2 === 0) {
                brandName.classList.add('table-secondary');
            } else {
                brandName.classList.add('table-light')
            }
            brandName.innerHTML = `<div class= 'row'>
        <div class= 'col-4'>${brand.name}</div> 
        <div class= 'col-4'>${Utils.percentFormat(brand.purchaseDiscount / 100)}</div>
        <div class= 'col-4'>${dollarUSLocale.format(brand.purchaseFee)}</div>
      </div>`;
            brandRow.appendChild(brandName);
            if (brand.cards?.length === 0) {
                let cardCell = document.createElement('td');
                cardCell.innerHTML = '';
                if (brandIdx % 2 === 0) {
                    cardCell.classList.add('table-secondary');
                } else {
                    cardCell.classList.add('table-light')
                }
                brandRow.appendChild(cardCell);
                tblBody.appendChild(brandRow);
            } else {
                brand.cards.forEach((card, cardIdx) => {
                    let cardCell;
                    if (cardIdx === 0) {
                        cardCell = document.createElement('td');
                        cardCell.innerHTML = `${card.productName} (${card.currency})`;
                        brandRow.appendChild(cardCell);
                        tblBody.appendChild(brandRow);
                    } else {
                        let row = document.createElement('tr');
                        cardCell = document.createElement('td');
                        cardCell.innerHTML = `${card.productName} (${card.currency})`;
                        row.appendChild(cardCell);
                        tblBody.appendChild(row);
                    }
                    if (brandIdx % 2 === 0) {
                        cardCell.classList.add('table-secondary');
                    } else {
                        cardCell.classList.add('table-light')
                    }
                });
            }

        });

        tblHead.appendChild(headers);
        tbl.appendChild(tblPurchaserHead);
        tbl.appendChild(tblHead)
        tbl.appendChild(tblBody);
        return tbl;
    }
    const downloadPDF = () => {
        setExcelLoader(true)
        // Assuming currentBrandData is an array of objects
        let pdf = createTable(brandList);

        var opt = {
            margin: [24, 15, 24, 15],
            filename: `Available brands for Purchaser Brands.pdf`,
            image: { type: 'jpg', quality: 0.98 },
            html2canvas: { scale: 2, logging: true, dpi: 192, letterRendering: true },
            jsPDF: { unit: 'mm', format: 'letter', orientation: 'portrait' },
            pagebreak: { mode: ['css'] }
        };

        html2pdf(pdf, opt);
        setTimeout(() => {
            setExcelLoader(false)
        }, 2000);
    };



    const downloadCsvFile = () => {
        setCsvLoader(true)
        let data = brandList?.sort((a, b) => {
            var textA = a?.name.toUpperCase();
            var textB = b?.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        
        })

        let csv = [];

        data?.forEach(brand => {
            if (brand?.cards?.length > 0) {
                brand?.cards.forEach(card => {
                    csv.push(`"${brand.id}","${brand.name}","${card.id}","${card?.productName}",${card?.currency ?? 'N.A.'},${Utils.percentFormat(brand?.purchaseDiscount / 100)},${dollarUSLocale.format(brand?.purchaseFee)}`)
                })
            } else {
                csv.push(`${brand.name},No cards Available,,${Utils.percentFormat(brand.purchaseDiscount / 100)},${dollarUSLocale.format(brand.purchaseFee)}`)
            }
        })

        csv = ` Brand id, Brand, Gift card id, Gift Card Type, Currency, Discount, Fee\n${csv.join('\n')}`
        csv = `Purchaser\n\n ${csv}`;

        // csv = `${props.purchaser.name}\n\n ${csv}`;

        const element = document.createElement("a");
        const file = new Blob([csv], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = `Available brands for Purchaser Brands.csv`;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        setTimeout(() => {
            setCsvLoader(false)   
        }, 2000);
        
    }
        

    const handleSearchInputChange = (event) => {
		const query = event.target.value.trim().replace(/\s+/g, ' ');;
		setSearchQuery(query);
	
		if (!query) {
			
			setBrandData(brandSearchData);
			
		} else {
			const searchResults = brandData?.filter((item) => {
				
					return item.name?.toLowerCase().includes(query.toLowerCase());
				
			});
	
			if (searchResults.length === 0  && !notificationShown) {
				Notify(alert, "danger", "Option is not valid corresponding for search  Or  No match found" );
				setNotificationShown(true); 
			} else if (searchResults.length > 0) {
				setNotificationShown(false); 
			}
			
			setBrandData(searchResults)
			setCurrentPage(1)
	
			
			
			return searchResults.length > 0 ? searchResults : "No match found";
		}
	};

    const handleLowFund = () =>{
        setLowFundLoader(true)
                if(lowFund === undefined || lowFund === "" || lowFund.length < 1 ){
                Notify(alert,"danger","Lowfund Field can not be empty")
                setTimeout(() => {
                 setLowFundLoader(false)   
                }, 1500);
                }else{
                 let LowFundObj = {
                    lowFundAlert : parseFloat(lowFund)
                 }   
                 purchaserCtl.lowFundCustomer(fundsData.id,LowFundObj,(data)=>{
                    if(data && !data.error){
                     Notify(alert,"success","Low funds upadated sucessfully") 
                     toggleLowFund();
                     setTimeout(() => {
                        setLowFundLoader(false);
                     }, 1500);
                     purchaserCtl.allFunds(purchaserId,(data)=>{
                        if(data && !data.error){
                         setFunds(data)
                        }
                    })
                    }else{
                        Notify(alert,"danger",data?.errorMessage)
                        setTimeout(() => {
                           setLowFundLoader(false) 
                        }, 1500);
                    }
                 })
                }
    }

    const handlelowFundClose = () =>{
        toggleLowFund()
    }

    const handleFundModalClose = () =>{
        setFundShow(false)
    }

    const editLowFundData = (data) =>{
        toggleLowFund()
        setFundsData(data)
        setLowFund(data?.lowFundAlert)
    }

const handleNaviagteFund = () =>{
    toggleFund()
}

const handleOrderNavigate = () =>{
    history.push({
        pathname: "/purchaser/purchaseorders"
        
      });
}

const handleBrands = () =>{
    const brandSection = document.getElementById("brandId");
    if (brandSection) {
      brandSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
}

const handleContactNavigate = () =>{
    history.push({
        pathname: "/purchaser/contacts"
        
      });
}

const registerLoaderFile = () =>{
    setTimeout(() => {
        setRegisterLoader(false)
    }, 1500);
}

const createorder = (orderData) => {
    const updatedOrderData = {
        ...orderData,
        brandName: brandName,
    };
    // setOrderData(updatedOrderData);

   
        history.push({
            pathname: "/purchaser/purchaseorders",
            state: {
                data: updatedOrderData,
                
                fromCart: true,
                showModal: true,
            },
        });
    
};


const addPayment = () =>{
    togglePayment()

		purchaserCtl.findCurrency(purchaserId, (dat) => {
			if (dat && !dat.error) {
			  const currecyData = dat.map(item => ({
				
				value: item.currencyId,
				label: item.currencyCode
			  }))
			  setCurrencyOption(currecyData)
			} else {
			  setCurrencyOption([]);
			}
		  });

}

        const sanitizeInput = (input) => {
            return input.replace(/[<>\/"'`;()]/g, ""); 
        };


        const onAddChange = (e) => {
        let { name, value } = e.target;

        if (name === "reference") {
            value = sanitizeInput(value); 
        }

        setBillingAdd({ ...billingAdd, [name]: value });
        };

        const handleCurrency = (options) =>{
            const currencyoptions = options?.value
            setBillingAdd({
                ...billingAdd,
                currencyId: currencyoptions 
            });
            setCurrencyValue(currencyoptions)
            
          }

          const fundPostData = () =>{
                setRegisterLoader(true)
                    if(billingAdd.funds === "" || billingAdd.funds < 0 || billingAdd.funds == 0){
                        Notify(alert, "warning","Funds can not be 0 or negative");
                        registerLoaderFile()
                        return;
                    }
                    if(billingAdd.currencyId === null || billingAdd.currencyId === undefined){
                        Notify(alert,"warning","Currency is mandatory");
                        registerLoaderFile()
                        return;
                    }
                    // togg()
                    
                    
                        let obj = billingAdd ;
                        if (obj) {
                            purchaseOrderCtl.fundDeposite(obj, (data) => {
                                if (data && !data.error) {
                                   
                                    Notify(alert, "success", "Fund deposite");
                                    registerLoaderFile()
                                    setTimeout(() => {
                                        history.push({
                                            pathname: "/purchaser/invoice"
                                        })
                                    }, 1000);
                                } else {
                                    Notify(alert, "danger", data.errorMessage ?? data.error);
                                    registerLoaderFile()
                                }
                            })
                        }
                    
                    

          }

    return (
        <>
        {loader ? 
         <div className='d-flex justify-content-center align-items-center flex-column vh-100'>
            <div className="spinner-border text-muted text-center"></div>
         </div>
         :
         <>
           <NotificationAlert ref={alert} />
            <div className='dashboardPage mt-3 '>
                {showInfo ? <OrderSummary handleClick={onOpenInfoModal} orders={orderDetail} token={newToken} />
                    :
                    <div className="contentArea container-fluid">
                        <h5 className='mb-3 fs-4'>Dashboard</h5>
                        <div className="row g-3">
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6" onClick={handleNaviagteFund} style={{cursor:"pointer"}}>
                                <div className="widgetOne">
                                    <p className='text-truncate' title="Available Funds">Available Funds</p>
                                    <h2 className='text-white'> {usDollarFunds.length > 0 ? `$${usDollarFunds[0]?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : "No funds found"}</h2>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                <div className="widgetOne" style={{cursor:"pointer"}} onClick={handleOrderNavigate}>
                                    <p className='text-truncate' title="Number of Orders">Number of Orders</p>
                                    <h2>{dashPrimaryData?.numberOfOrders}</h2>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-5">
                                <div className="widgetOne" style={{cursor:"pointer"}} onClick={handleBrands}>
                                    <p className='text-truncate' title="Brands Available">Brands Available</p>
                                    <h2>{brandData?.length}</h2>
                                </div>
                            </div>
                            <div className="col-xl-3 col-lg-6 col-md-6 col-sm-7">
                                <div className="widgetOne" style={{cursor:"pointer"}} onClick={handleContactNavigate}>
                                    <p className='text-truncate'>Primary Contact</p>
                                    <h3>{dashPrimaryData?.primaryContactName}</h3>
                                    <a href="mailto:ricardo@ncentiva.com" className='text-truncate d-block' title="ricardo@ncentiva.com">{dashboardData?.primaryContactEmail}</a>
                                </div>
                            </div>
                        </div>
                        <div className="card my-4 table-widget">
                            <div className="card-body p-0">
                                <div className="card-header pt-4 pb-0">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <h6>Last 4 Orders</h6>
                                        </div>
                                        {/* <div className="col-auto">
                                <button className='btn p-0 shadow-none'>View All</button>
                            </div> */}
                                    </div>
                                </div>
                                <div className="card-body py-0">
                                    <div className="table-responsive">
                                        <table className='table table-borderless mb-4'>
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th width="250px">Name</th>
                                                    
                                                    <th>Currency</th>
                                                    <th width="140px">Total Gift Card</th>
                                                    <th width="140px">Total Amount</th>
                                                    <th>Quantity</th>
                                                    <th>Status</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {dashboard?.length > 0 ? dashboard?.map((data, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{data?.createdAt}</td>
                                                            <td>{data?.name}</td>
                                                            
                                                            <td>{data?.currency}</td>
                                                            <td>{data?.subtotal}</td>
                                                            <td>{data?.totalAmount}</td>
                                                            <td>{data?.totalQuantity}</td>
                                                            <td>{statusData(data?.status)}</td>
                                                            <td data-bs-toggle="tooltip" title="Info">
                                                                <button type="button" onClick={() => onOpenInfoModal(data)} className="j_orders_btn_dashboard" data-toggle="modal"
                                                                // data-target="#staticBackdrop"
                                                                >
                                                                    <i className="bi bi-info-circle-fill text-primary"></i>
                                                                </button></td>
                                                        </tr>
                                                    )
                                                }) :

                                                    <tr>
                                                        <td colSpan={8}>No orders found !</td>

                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card  table-widget" style={{ margin: "0px", marginBottom: "0" }}>
                            <div className="card-body p-0" id='brandId'>
                                <div className="card-header pt-4 pb-0">
                                    <div className="row justify-content-between">
                                        <div className="col-auto">
                                            <h6>Brands</h6>
                                        </div>
                                        {/* <div className="col-auto">
                                <button className='btn p-0 shadow-none'>View All</button>
                            </div> */}
                                    </div>
                                    <div className="col-xl-12 d-flex justify-content-between flex-sm-row flex-column p-0">
                                        <div className="col-12 col-sm-5 col-xl-5 searchSort position-relative mb-3 mb-sm-0" style={{padding:"0px",marginTop:'4px'}}>
                                            <input onChange={(e) => handleSearchInputChange(e)} defaultValue={searchQuery} type="text" placeholder='Search by brand' className='form-control pe-5' />
                                            <button className='d-flex align-items-center btn position-absolute p-0 h-100 px-3'  style={{right:"0",top:"50%",transform:"translate(0%,-50%)", background: "#2665F2",color:"white"}}><i className='bx bx-search' style={{color:"white"}}></i></button>
                                        </div>
                                <button className='btn btn-primaryTwo py-2' style={{ fontSize: '12px' }} onClick={() => toggle()}>All Download <i className='bx bxs-download'></i></button>

                                    </div>
                                </div>
                                <div className="card-body py-0">
                                <div className='text-end py-3'>
                                </div>
                                    <div className="table-responsive" style={{maxHeight: "700px", overflowY:"auto"}}>
                                        <table className='table table-borderless mb-4 lnmvshjk' style={{tableLayout: 'fixed', minWidth: '600px'}}>
                                            <thead  style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                                <tr>
                                                    <th width="140px" style={{verticalAlign:"middle"}}>Brand </th>
                                                    <th style={{verticalAlign:"middle"}}>Brand Name
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th style={{verticalAlign:"middle"}}>Category
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th style={{verticalAlign:"middle"}}>Availability
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th style={{verticalAlign:"middle"}}>Discount
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th width="" style={{verticalAlign:"middle"}}>Fee
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th width="" style={{verticalAlign:"middle"}}>Currency
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th width=""style={{verticalAlign:"middle"}}>Gift Card(s)
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                    <th width="" style={{verticalAlign:"middle"}}>Delivery Method
                                                        {/* <i className="bi bi-sort-down"></i> */}
                                                    </th>
                                                  
                                                </tr>
                                            </thead>
                                            <tbody className='table_row_design'>
                                                {currentBrandData?.length > 0 ? currentBrandData?.map((data, index) => {
                                                    return (
                                                        <tr key={index} onClick={() => {
                                                            if (data?.giftCardTypes?.length > 0) {
                                                            giftcardModal(data?.giftCardTypes, data?.name);
                                                            }
                                                        }} style={{cursor: data?.giftCardTypes?.length === 0 ? "not-allowed" : "pointer"}} 
                                                        title={`${data?.giftCardTypes?.length === 0  ? "No gift cards available" : "Click to view gift cards"}`}  >
                                                            
                                                            <td>
                                                           
                                                                 <img src={brandCtl.logoByUuid(data?.logoUuid)} alt="" className='brandImgStyle'
                                                                  style={{width:"100px",height:"auto"}} 
                                                                     />
                                                          
                                                            
                                                            </td>
                                                            <td>{data?.name}</td>
                                                            <td>{getCategoryName(data?.brandCategory)}</td>
                                                            <td style={{padding:"28px"}}>{data?.availability == true ? "Yes" : "No"}</td>
                                                            <td>{data?.purchaseDiscount?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                                                            <td>{data?.purchaseFee}</td>
                                                            <td style={{padding:"24px"}}>{data?.giftCardTypes[0]?.currency}</td>
                                                            <td style={{ cursor: "pointer", fontWeight: "600" }}> <span onClick={() => giftcardModal(data?.giftCardTypes)}>{data?.giftCardTypes?.length} Gift Card </span>  </td>
                                                            <td>{data?.deliveryMethod}</td>
                                                            
                                                            
                                                        </tr>
                                                    )
                                                }) 
                                               :
                                                
                                                    <tr>
                                                        <td colSpan={9}>No brands found !</td>

                                                    </tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                            <div>
                                                <div colspan="10">
                                                    <div className="d-flex justify-content-end  paginate align-items-end mb-2">
                                                        <CustomPagination
                                                            totalItems={brandData?.length}
                                                            currentPage={currentPage}
                                                            onPageChange={handlePageChange}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
                <div className="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header custom_header_colour align-items-center">
                                <h5 className="modal-title mb-0" id="staticBackdropLabel">Modal title</h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <h3 className='text-center'>No Data</h3>
                            </div>

                        </div>
                    </div>
                </div>

            </div>
            </>
}


            <Modal isOpen={modal} toggle={toggle} backdrop="static" size="md">
                <ModalHeader className=" custom_header_colourTwo" toggle={toggle}>Available Brands</ModalHeader>
                <ModalBody>
                    <Row className="mx-3">
                        <Col xs="12" className="d-flex justify-content-center mb-2">
                            <Button  onClick={downloadCsvFile} className="mx-2 btn btn-primaryTwo" disabled={csvLoader}>
                                Download excel file
                               {
                                csvLoader && 
                                <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{
                                  margin: "0px 8px"
                                }}
                              />
                               }
                            </Button>
                        </Col>
                        <Col xs="12" className="d-flex justify-content-center">
                            <Button onClick={downloadPDF} className="mx-2 btn btn-primaryTwo" disabled={excelLoader}>
                                Download PDF file{
                                    excelLoader && <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{
                                      margin: "0px 8px"
                                    }}
                                  />
                                }
                            </Button>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="secondary" onClick={toggle}>Close</Button>{' '}
                </ModalFooter>
            </Modal>

            <Modal isOpen={giftShow} toggle={toggleGiftCard} backdrop="static" centered={true} size="xl">
                <ModalHeader toggle={handleCloseGiftModal} className='custom_header_colourTwo d-flex align-items-center justify-content-between'> Gift Card Details</ModalHeader>
                <ModalBody>
                    <div className="card my-4 table-widget">
                        <div className="card-body p-0">
                            <div className="card-header pt-4 pb-0">
                                {/* <Link to="" className=' text-decoration-none  j_back_btn mb-4'><i class="bi bi-arrow-left me-1 fw-bolder"></i>Back</Link> */}
                                <div className="row justify-content-between">
                                    <div className="col-auto">
                                        <h6>Gift Card</h6>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body py-0">
                                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                                    <table className='table table-borderless mb-4'>
                                        <thead>
                                            <tr>
                                                <th >Brand</th>
                                                
                                                <th className="text-center" width="150px" >Product Name</th>
                                                <th className="text-center" width="100px">Currency</th>
                                                <th className="text-center" width="250px">Type of Denomination</th>
                                                <th className="text-center">Discounts</th>
                                                <th className="text-center">Fees</th>
                                                <th></th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cardCurrentBrandData?.length > 0 ? cardCurrentBrandData.map((giftData, index) => {
                                                return (
                                                    <tr key={index}>
                                                        <td><span><img src={cardTypeCtl.image(giftData?.imageUuid)} alt="" style={{ maxWidth: "110px" }}/></span></td>
                                                        
                                                        <td className="text-center">{giftData?.productName}</td>
                                                        <td className="text-center">{giftData?.currency}</td>
                                                        <td className="text-center">{(giftData?.minAmount == 0 && giftData?.maxAmount == 0) ? "Fixed" : "Variable"}</td>
                                                        <td className="text-center">{giftData?.purchaseDiscount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}%</td>
                                                        <td className="text-center">${giftData?.purchaseFee}.00</td>
                                                        <td><Button onClick={()=>createorder(giftData)} title='Click to Add New Order'>Add</Button></td>
                                                    </tr>
                                                )

                                            })
                                                : ""}

                                        </tbody>
                                        {cardTypeData?.length > 10 ? 
                                        <div className="pagination_area">
                                            <CustomCardPagination
                                                totalItems={cardTypeData?.length}
                                                currentPage={cardCurrentPage}
                                                onPageChange={handleCardPageChange}
                                            />
                                        </div>
                                        :""}
                                    </table>
                                </div>
                            </div>

                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button type="button" color="secondary" onClick={handleCloseGiftModal}>Cancel</Button>

                </ModalFooter>
            </Modal>
            <Modal isOpen={fundShow} toggle={toggleFund} backdrop="static" centered={true} size="xl">
                <ModalHeader toggle={handleFundModalClose} className='custom_header_colourTwo'>Funds Information</ModalHeader>
                <ModalBody>
                    <div className='table-responsive'>
                    <table className="table">
                        
                        <thead>
                    <tr>
                        <th>Purchaser Name</th>
                        <th>Funds</th>
                        <th>Currency</th>
                        <th>Prepaid Funds</th>
                        
                        {funds?.some(fund => fund.creditThreshold !== 0) && (
                            <>
                                <th>Credit Threshold</th>
                                <th>Credit Limit</th>
                                
                            </>
                        )}
                        <th>Low fund alert</th>
                        <th></th>
                    </tr>
                </thead>
               
            
              <tbody>
                {funds?.length > 0 ? funds.map((fund, index) => (
                    <tr key={index}>
                        <td>{fund?.purchaserName}</td>
                        <td>${fund?.funds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>{fund?.currencyName}</td>
                        <td>${fund?.prepaidFunds?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        {fund.creditThreshold !== 0 && (
                            <>
                                <td>${fund?.creditThreshold?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                                <td>${fund?.creditLimit?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                            </>
                        )}
                        <td>${fund?.lowFundAlert?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</td>
                        <td>
                        <button onClick={() => editLowFundData(fund)} className='btn btn-primaryTwo ms-2 edit edit_button' data-toggle="tooltip" data-placement="bottom" title='Edit'><i className="bi bi-pen"></i></button>
                        </td>
                       
                    </tr>
                )) : (
                    <tr>
                        <td colSpan={funds?.some(fund => fund.creditThreshold !== 0) ? 8 : 6}>No data available</td>
                    </tr>
                )}
            

                
             </tbody>
            
                    </table>
                    </div>
                </ModalBody>
                <ModalFooter className='d-flex justify-content-between'>
                    
                <Button
					className="py-2 btn-primaryTwo"
						initial={{ x: "-500%", opacity: 0 }}
						animate={{
							x: 0,
							opacity: 1,
							transition: { delay: 0.4, duration: 0.5 },
						}}
						
						onClick={addPayment}
					>
						<i className="fas fa-shopping-cart" /> Register Payment
					</Button>
                    <Button type="button" color="secondary" onClick={handleFundModalClose}>Close</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={lowFundModal} toggle={toggleLowFund} backdrop="static" centered={true} size="lg">
            <ModalHeader toggle={handlelowFundClose} className='custom_header_colourTwo'>Set Low Fund Alert</ModalHeader>
            <ModalBody>
                <div className='d-flex' style={{ height: "118px" }}>
                    <div className='col-lg-8' style={{ marginBottom: "18px", marginTop: "10px" }}>
                        <label htmlFor="low funds" className="form-label">Set Low Fund Alert</label>
                        <input
                            type="number"
                            className='form-control'
                            id="low funds"
                            placeholder='Enter Threshold Amount'
                            value={lowFund}
                            onChange={(e) => setLowFund(e.target.value)}
                        />
                    </div>
                    <div className="col-auto" onClick={handleLowFund} style={{ marginTop: "40px" }}>
                        <button className='btn btn-primaryTwo py-2' disabled={lowFundLoader}>
                            <i className='bx bx-save me-1'></i>Save{
                                lowFundLoader && <Spinner
                                as="span"
                                animation="border"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                style={{
                                  margin: "0px 8px"
                                }}
                              />
                            }
                        </button>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
        <Button type="button" color="secondary" onClick={handlelowFundClose}>Close</Button>
       </ModalFooter>
        </Modal>

        <Modal
				isOpen={paymentAdded}
				toggle={togglePayment}
				backdrop="static"
				centered={true}
				size="lg"
			>
				<ModalHeader toggle={togglePayment} className="custom_header_colourTwo d-flex align-items-center justify-content-between">
					<h2 className="mb-0" style={{color:"white"}}> Deposit Funds</h2>
				</ModalHeader>
				<Form>
					<ModalBody>
						<Form >
							<Row >
								<Col md="6" style={{ position: "relative" }}>
									<FormGroup>
										<Label for="funds">Topup Amount<span className="required-asterisk">*</span></Label>
										<Input
											onChange={onAddChange}
											name="funds"
											type="number"
											id="funds"
											value={billingAdd?.funds || ''}
											placeholder="Enter Topup Amount"
										/>
									</FormGroup>
								</Col>
								<Col md="6" style={{ position: "relative" }}>
									<FormGroup>
									<label for="Currency">Currency<span className="required-asterisk">*</span></label>
									<Select 
									options={currencyOption}
									isMulti={false}
									onChange={handleCurrency}
									isClearable={true} 
									id="Currency"/>
									</FormGroup>
									</Col>

								<h4
									className="ncentiva-purchase-header-section text-dark"
									onClick={() => setBillingInfo(!billingInfo)}
									style={{ cursor: "pointer" }}
								>
									<i
										className={
											billingInfo
												? "fas fa-chevron-up"
												: "fas fa-chevron-down"
											
										}
									/>
									&nbsp;&nbsp;Billing Address
								</h4>

								<Collapse isOpen={billingInfo} >
									<Row>
										<Col md="12">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-address"
												>
													Address
												</label>
												<Input
													className="bg-white"
													id="street"
													value={billingAdd?.street}
													name="street"
													onChange={onAddChange}
													placeholder="Home Address"
													type="text"
												/>
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<Col lg="4">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-city"
												>
													City
												</label>
												<Input
													className="bg-white"
													value={billingAdd?.city}
													name="city"
													onChange={onAddChange}
													id="city"
													placeholder="City"
													type="text"
												/>
											</FormGroup>
										</Col>
										<Col lg="4">
											<FormGroup>
												<Label for="billingCoutryId">Country</Label>
												<Input type="select" name="countryId" value={billingAdd?.countryId} id="countryId" onChange={onAddChange}>
													<option hidden={true}>Select a country</option>
													{country.map((count) => (
														<option key={count.id} value={count.id}>
															{count.name}
														</option>
													))}
												</Input>
											</FormGroup>
										</Col>
										<Col lg="4">
											<FormGroup>
												<label
													className="form-control-label"
													htmlFor="input-country"
												>
													Postal code
												</label>
												<Input
													className="bg-white"
													onChange={onAddChange}
													value={billingAdd?.postalCode}
													name="postalCode"
													id="postalCode"
													placeholder="Postal code"
													type="text"
												/>
											</FormGroup>
										</Col>
									</Row>
								</Collapse>

								<Col md="12" style={{ position: "relative" }}>
									<FormGroup>
										<Label for="reference">Your reference</Label>
										<Input
											type="text"
											id="reference"
											name="reference"
											value={billingAdd?.reference}
											onChange={onAddChange}
											placeholder="Enter Reference"
										/>
									</FormGroup>
								</Col>
							</Row>
						</Form>
					</ModalBody>
					<ModalFooter className="justify-content-start">
						<Row>
							<Col md="12" >
								<button type="button" class="btn btn-primaryTwo" onClick={fundPostData} disabled={registerLoader}>
									Deposit Funds{
										registerLoader && 
										<Spinner
										as="span"
										animation="border"
										size="sm"
										role="status"
										aria-hidden="true"
										style={{
										margin: "0px 8px"
										}}
									/>
									}
								</button>
							</Col>
						</Row>

					</ModalFooter>
				</Form>
			</Modal>
        </>
    )
}

export default Dashboard;

// src="https://back-dev.ncentiva.com/public/backoffice/brand/logo/e268eda1-2578-40cd-aeb1-b1c8c8f94d35 "

// src="https://back-dev.ncentiva.com/public/backoffice/brand/logo/Amazon.com"
